import React from 'react'
let selected = '';
let vector_2 = [1];

const Info = function info ({user,address,cities,onChange,onSubmit,onChangeCity,form,click,addressList,
    onSubmitAddress,formAddress,onChangeAddress,onChangeAddressCity,selectAddress,
    onSubmitAddressAdd,formAddressAdd,onChangeAddressAdd,onChangeAddressCityAdd}){
    return (
        <main>
            <div className="back flex w90">
                <a href={https} className="flex">
                    <img src={https+"img/back.svg"} alt="⬅"/>
                    <span>Atrás</span>
                </a>
                </div>
            
                <div className="titMobProfile flex">
                <h3>Perfil</h3>
            </div>
            <section className="profile ">
                <div className="container w90 colflex">
                
                    <div className="sec1 dnone">
                        <h3>Perfil de usuario</h3>
                        <img src={https+"img/userLog.svg"} alt="user-icon"/>
                        <p>Usuario</p>
                        <span>{nameUser}</span>
                        <a href={https+"profile"}>Ver Datos</a>
                        <a className='a_2' href={https+"orders"}>Ver compras</a>
                        <a href={https+'api/logout'}>Salir</a>
                    </div>
                
                    <div className="colflex sepSecs">
                        <div className="sec2">
                            <h3 className="dnone">
                                Edita tus datos personales
                            </h3>
                            <form id="formUpdate" className="container grid w90" action="" onSubmit={onSubmit}>
                                <div className="colflex">
                                    <label for="">Nombre</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={form.name}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="colflex">
                                    <label for="">Apellidos</label>
                                    <input
                                        type="text"
                                        name="lastname"
                                        value={form.lastname}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="colflex">
                                    <label for="">Cedula de ciudadanía</label>
                                    <input 
                                        type="text" 
                                        name="identy"
                                        value={form.identy}
                                        onChange={onChange}    
                                    />
                                </div>
                                <div className="colflex">
                                    <label for="">Email</label>
                                    <input
                                        type="text"
                                        name="mail"
                                        value={form.mail}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="colflex">
                                    <label for="">Teléfono</label>
                                    <input
                                        type="text"
                                        name="phone"
                                        value={form.phone}
                                        onChange={onChange}
                                    />
                                </div>
                                <button style={{visibility: 'hidden'}} id="clickSubmit" type='submit'></button>
                            </form>
                        </div>
                    
                        <hr className="w90"/>
                    
                        <div className="sec3 flex w90">
                            <div className="colflex">
                                <label for="">Contraseña Actual</label>
                                <input 
                                    type="password" 
                                    name="password"
                                    value={form.password}
                                    onChange={onChange}       
                                />
                            </div>
                            <div className="colflex">
                                <label for="">
                                    Nueva Contraseña (opcional)
                                </label>
                                <input 
                                    type="password" 
                                    name="password_new"
                                    value={form.password_new}
                                    onChange={onChange}       
                                />
                            </div>
                        </div>
                        
                        <div className="btnSessions w80 colflex"
                            style={{margin: '0px 5%'}}
                        >
                                <a onClick={click} className="btnSaveData">Guardar y actualizar</a>
                        </div>
                        
                        <div className="subTotal colflex">
                            {vector_2.map((v) => {
                                if(addressList.length > 0){
                                    return (
                                        <div className="flex address">
                                            <p style={{
                                                textAlign: 'left',
                                                width: '100%',
                                                color: '#292929'
                                                }}>
                                                Lista de Direcciónes
                                            </p>
                                            <a rel="modal:open" 
                                                href="#userAddressAdd"
                                                className='iconAdd'
                                            >
                                                <img src={https+'img/add-icon.svg'}/>
                                            </a>
                                        </div>
                                    )
                                }
                            })}
                            {addressList.map((a)=>{
                                return (
                                    <div className="flex address">
                                        <p>
                                            <label 
                                                onClick={() => changeAddress(a.id)}
                                                for={"address_" + a.id}
                                            >
                                                {a.address}
                                            </label>
                                        </p>
                                        <a onClick={() => selectAddress(a.id)} rel="modal:open" href="#userAddress">
                                            <img src={https+'img/edit.svg'}/>
                                        </a>
                                    </div>
                                )
                            }
                            )}
                        </div>
                
                    </div>
                
                </div>
                
                <div className="btnSessions w80 colflex">
                    <a href={https+"orders"} className="btnOrders">Ver compras</a>
                    <a href={https+'api/logout'} className="btnLogOut">Salir</a>
                </div>
            </section>


            <div className="modal userModal" id="userAddress">
                <div className="container colflex">
                    <div className="tittle">
                        <h3>
                            Editar Dirección
                        </h3>
                    </div>
                    <form id="formAddress" action="" onSubmit={onSubmitAddress}>
                        <input 
                            type="text"
                            placeholder="Ingresa tu Direccion"
                            name="address"
                            value={formAddress.address}
                            onChange={onChangeAddress}           
                        />
                        <select
                            name="city_id"
                            onChange={onChangeAddressCity}
                        >
                            <option>Selecciona tu Ciudad</option>
                            {cities.map((c) => {
                                if(formAddress.city_id == c.CiuCodigo){
                                    return (
                                        <option selected value={c.CiuCodigo} key={c.CiuCodigo}>{c.CiuNombre}</option>
                                    )  
                                }else{
                                    return (
                                        <option value={c.CiuCodigo} key={c.CiuCodigo}>{c.CiuNombre}</option>
                                    )  
                                }                         
                            }    
                            )}
                        </select>
                        <input 
                            type="text" 
                            placeholder="Ingresa tu Barrio"
                            name="town"
                            value={formAddress.town}
                            onChange={onChangeAddress}
                        />
                        <input 
                            type="password" 
                            placeholder="Ingresa tu Contraseña"
                            name="password"
                            value={formAddress.password}
                            onChange={onChangeAddress}           
                        />
                        <textarea
                            name="description"
                            value={formAddress.description}
                            onChange={onChangeAddress}
                            placeholder='Detalles adicionales de la dirrecion...'
                        ></textarea>
                        <button type="submit">
                            <a className="initSession">
                                Actualizar Dirección
                            </a>
                        </button>
                    </form>
                </div>
            </div>

            <div className="modal userModal" id="userAddressAdd">
                <div className="container colflex">
                    <div className="tittle">
                        <h3>
                            Agregar Dirección
                        </h3>
                    </div>
                    <form
                        id="formAddressAdd" 
                        action="" 
                        onSubmit={onSubmitAddressAdd}
                    >
                        <input 
                            type="text"
                            placeholder="Ingresa tu Direccion"
                            name="address"
                            value={formAddressAdd.address}
                            onChange={onChangeAddressAdd}           
                        />
                        <select
                            name="city_id"
                            onChange={onChangeAddressCityAdd}
                        >
                            <option>Selecciona tu Ciudad</option>
                            {cities.map((c) => {
                                return (
                                    <option value={c.CiuCodigo} key={c.CiuCodigo}>{c.CiuNombre}</option>
                                )                       
                            }    
                            )}
                        </select>
                        <input 
                            type="text" 
                            placeholder="Ingresa tu Barrio"
                            name="town"
                            value={formAddressAdd.town}
                            onChange={onChangeAddressAdd}
                        />
                        <input 
                            type="password" 
                            placeholder="Ingresa tu Contraseña"
                            name="password"
                            value={formAddressAdd.password}
                            onChange={onChangeAddressAdd}           
                        />
                        <textarea
                            name="description"
                            value={formAddressAdd.description}
                            onChange={onChangeAddressAdd}
                            placeholder='Detalles adicionales de la dirrecion...'
                        ></textarea>
                        <button type="submit">
                            <a className="initSession">
                                Guardar Dirección
                            </a>
                        </button>
                    </form>
                </div>
            </div>
        </main>
    )
}

export default Info
